export default __webpack_public_path__ + "static/media/HUD-Effects-03.d1b87153.jpg";